/** A filter's selection after toggling ``value``: added if absent, else removed. */
export function toggleValue(selected: string[], value: string): string[] {
  return selected.includes(value)
    ? selected.filter((item) => item !== value)
    : [...selected, value];
}

/** "Landscape Forms (1,021)" — the count grouped for readability. */
export function formatCountLabel({
  name,
  count,
}: {
  name: string;
  count: number;
}): string {
  return `${name} (${count.toLocaleString("en-US")})`;
}
